import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function Filter(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filter}>
      <FilterMenu
        filter={props.filter}
        placeholder={t("kanban.filters.resourceFilter.all")}
        setFilter={(filter) => {
          props.setFilter({
            ...props.filter,
            groups: filter.groups,
            projectsElementsTags: filter.projectsElementsTags,
            resources: filter.resources,
            resourceTags: filter.resourceTags,
          });
        }}
        views={["projectsElementsTags", "resources", "groups"]}
      />
    </div>
  );
}

export { Filter };
